import { NotificationType, NotificationActions, } from './types';
import uuidv4 from 'uuid/v4';
import { selectNotification } from './selectors';
const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const showNotification = (text, type, actions) => async (dispatch, getState) => {
    const id = uuidv4();
    const notification = {
        id,
        text,
        type,
        actions,
    };
    dispatch({
        type: NotificationActions.SHOW_NOTIFICATION,
        payload: notification,
    });
    if (type !== NotificationType.DIALOG) {
        await timeout(3000);
        if (id === selectNotification(getState()).id) {
            dispatch({ type: NotificationActions.HIDE_NOTIFICATION });
        }
        await timeout(500);
        if (id === selectNotification(getState()).id) {
            dispatch({ type: NotificationActions.CLEAR_NOTIFICATION });
        }
    }
};
export const hideNotification = () => async (dispatch, getState) => {
    const id = selectNotification(getState()).id;
    dispatch({ type: NotificationActions.HIDE_NOTIFICATION });
    await timeout(500);
    if (id === selectNotification(getState()).id) {
        dispatch({ type: NotificationActions.CLEAR_NOTIFICATION });
    }
};
